export default {"src":"/_next/static/media/feature-icon1-2.96d30118.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};